import { RevelioPageId } from '../../PageConfigProvider/types';

/**
 * Pages whose grouped bars never show a legend, whatever "Show Legend" says.
 * Shared by ChartSelector and the PNG export so the two can't disagree.
 */
const GROUPED_BAR_LEGEND_HIDDEN_PAGES: ReadonlySet<string> = new Set([
  RevelioPageId.ROLE_POSTINGS,
  RevelioPageId.GEOGRAPHY_POSTINGS,
  RevelioPageId.COMPANY_POSTINGS,
]);

export const isGroupedBarLegendHiddenOnPage = (pageId?: string): boolean =>
  pageId !== undefined && GROUPED_BAR_LEGEND_HIDDEN_PAGES.has(pageId);
